import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20online%20shopping%20concept%20with%20kraft%20paper%20shopping%20bags%20gift%20boxes%20and%20satin%20ribbon%20on%20a%20soft%20sage%20green%20background%2C%20premium%20retail%20photography%2C%20soft%20natural%20light%2C%20minimal%20clean%20composition%2C%20warm%20neutral%20accents&width=1600&height=800&seq=cta-bg-2&orientation=landscape&nocache=true"
          alt="CSSBuy Spreadsheet shopping"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 section-padding max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 mb-4 md:mb-6">
          {t('cta.title')}
        </h2>
        <p className="text-base md:text-lg text-background-200/90 leading-relaxed mb-8 md:mb-10 max-w-2xl mx-auto">
          {t('cta.subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="btn-primary text-base px-8 py-3.5 w-full sm:w-auto"
          >
            <i className="ri-file-list-3-line mr-2"></i>
            {t('cta.buttonSpreadsheet')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="btn-accent text-base px-8 py-3.5 w-full sm:w-auto"
          >
            <i className="ri-shopping-cart-line mr-2"></i>
            {t('cta.buttonBuy')}
          </a>
        </div>

        <div className="mt-6">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center text-sm text-background-200/80 hover:text-background-50 transition-colors underline underline-offset-4"
          >
            <i className="ri-external-link-line mr-1.5"></i>
            {t('cta.buttonVisit')}
          </a>
        </div>
      </div>
    </section>
  );
}